import { render, staticRenderFns } from "./NavigationAlert.vue?vue&type=template&id=01d8709e&scoped=true&"
import script from "./NavigationAlert.vue?vue&type=script&lang=js&"
export * from "./NavigationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8709e",
  null
  
)

export default component.exports